import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GDPRService } from 'src/app/core/services/rulebook/gdpr.service';
import { MatAutocomplete,  MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { FormControl } from '@angular/forms';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { LibraryType, ReportTempateModel, RulebookLibraryMenu } from 'src/app/core/models/rulebook/rulebook-library-menu';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { RulebookDetailsDD } from 'src/app/core/models/rulebook/rulebook-details-dd';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from '../../distributed-ui-components';


@Component({
  selector: 'app-rulebook-settings',
  templateUrl: './rulebook-settings.component.html',
  styleUrls: ['./rulebook-settings.component.scss']
})
export class RulebookSettingsComponent implements OnInit {
  isCollapsedDD: ICollapsedOrOpen[];
  allLibraryMenu!: Array<RulebookLibraryMenu>;
  ruleBookDD: RulebookDetailsDD;
  reportTemplate:ReportTempateModel;
  @ViewChild('rulebookInput', { static: false })
  rulebookInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rulebookAutocomplete', { static: false })
  rulebookAutocomplete!: MatAutocomplete;
  @ViewChild('trigautoRulebook')
  trigautoRulebook!: MatAutocompleteTrigger;
  searchRulebookCntrl: FormControl = new FormControl();
  searchedRulebook: FilterViewModel[] = [];
  searchStr = '';
  allRulebook: FilterViewModel[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ruleDD: string[] = [];
  removable = true;
  alertDialogModel: AlertDialogModel;
  toastModel: ToastViewModel;
  isToastShow = false;
  isLoading: boolean = false;
  constructor(private gdprService: GDPRService, public dialog: MatDialog) {
    this.isCollapsedDD = [];
    this.ruleBookDD = new RulebookDetailsDD();
    this.alertDialogModel = new AlertDialogModel();
    this.toastModel = new ToastViewModel();
    this.reportTemplate = new ReportTempateModel();
  }

  ngOnInit(): void {
    this.gdprService.getLibraryName(LibraryType.Rulebook).subscribe((result: any) => {
      this.allLibraryMenu = result;
    });
    this.gdprService.getRuleBookDD().subscribe((result: any) => {
      this.ruleBookDD.rulebook = result;
      this.searchedRulebook = this.ruleBookDD.rulebook;
      this.allRulebook = this.ruleBookDD.rulebook;
      this.filterRulebooks();
    });
    this.ddListData();
    this.isCollapsedDD.push({ value: true, title: "Collapsed" });
    this.isCollapsedDD.push({ value: false, title: "Open" });
  }

  
  ddListData(): void {
    this.searchRulebookCntrl.valueChanges.subscribe((term: any) => {
      this.searchedRulebook = term ? this.filterRulebook(term) : this.ruleBookDD.rulebook;
    });
  }
  filterRulebook(search: string): any {
    return this.searchedRulebook.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  selectedMultipleRulebook(event: MatAutocompleteSelectedEvent, rulrBookstring:string, row:number): void {
    let ruleArray:any = [];
    if (rulrBookstring) {
      ruleArray = rulrBookstring.split("||");
    }
    let sameValueRow = this.allLibraryMenu.filter(
      obj => obj.ruleBook?.split('||').includes(event.option.viewValue));
    if (sameValueRow.length == 0) {
      ruleArray.push(event.option.viewValue);
      this.allLibraryMenu[row].ruleBook = ruleArray.join('||');
      this.rulebookInput.nativeElement.value = '';
      this.searchRulebookCntrl.setValue(null);
      this.searchRulebookCntrl.disable();
      this.searchRulebookCntrl.enable();
    }
    else {
      this.warningAlert('To select this please remove from other row');
      this.rulebookInput.nativeElement.value = '';
      this.searchRulebookCntrl.setValue(null);
      this.searchRulebookCntrl.disable();
      this.searchRulebookCntrl.enable();
    }
    // filter rulebooks after selection
    this.filterRulebooks();
  }
  addRow() {
    if(!this.allLibraryMenu){
      this.allLibraryMenu = [];
      this.allLibraryMenu.push(new RulebookLibraryMenu());
    }
    else{
      this.allLibraryMenu.unshift(new RulebookLibraryMenu());
    }
    if (this.allLibraryMenu.length >0) {
      this.allLibraryMenu[0].isActive = true;
    }
  }
  addRulebook(event: MatChipInputEvent, rulebookstring:any, row:number): void {
    const value = event.value;
    if (!this.rulebookAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let ruleArray:any = [];
        if (rulebookstring) {
          ruleArray = rulebookstring.split("||");
        }
        let sameValueRow = ruleArray.filter(
          (          obj: string) => obj === value);

        if (sameValueRow.length == 0) {
          ruleArray.push(value);
          this.allLibraryMenu[row].ruleBook = ruleArray.join('||');
        }
      }
      else {
        this.allLibraryMenu[row].ruleBook = rulebookstring.join('||');
      }
      event.chipInput!.clear();
      this.searchRulebookCntrl.setValue(null);
      this.filterRulebooks();
    }
  }
  removeRulebook(rulebook: string, row:number): void {
    let rulebookArray:string[] = [];
    if (this.allLibraryMenu[row].ruleBook) {
      rulebookArray = this.allLibraryMenu[row].ruleBook.split("||");
    }
    const index = (rulebookArray as string[]).indexOf(rulebook);
    if (index >= 0) {
      (rulebookArray as string[]).splice(index, 1);
      this.allLibraryMenu[row].ruleBook = rulebookArray.join("||");
    }
  }
  removeRulebookDetails(index:number, id:number): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Item') {
        if (id && id > 0) {
          this.isLoading = true;
          this.gdprService.deleteLibraryName(id).subscribe((data: any) => {
            if (data.result == "Delete successfully") {
              this.allLibraryMenu.splice(index, 1);
              this.filterRulebooks();
              this.isLoading = false;
              this.successAlert('Delete successfully');
            }
          });
        }
        else {
          this.allLibraryMenu.splice(index, 1);
          this.successAlert('Delete successfully');
        }

      }
    });
  }

  saveRulebookDetails(index:number) {
    if (this.allLibraryMenu[index].libraryName && !this.allLibraryMenu[index].isLibraryNameExist) {
      this.isLoading = true;
      this.allLibraryMenu[index].type = LibraryType.Rulebook;
      this.gdprService.saveLibraryName(this.allLibraryMenu[index]).subscribe((data: any) => {
        if (data?.result) {
          this.allLibraryMenu[index].id = data.result;
          this.filterRulebooks();
          this.isLoading = false;
          this.successAlert('Save successfully');
        }
      });
    }
    else {
      this.warningAlert('Sidebar is not correct');
      if(!this.allLibraryMenu[index].libraryName){
        this.allLibraryMenu[index].isLibraryNameRequired = true;
      }
    }
  }

  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  successAlert(msg: string): void {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  collapsedFunction(i:number, value: boolean) {
    if (value) {
      this.allLibraryMenu[i].isCollapsed = true;
    }
    else {
      this.allLibraryMenu[i].isCollapsed = false;
    }

  }
  onKeydownLibraryName(i:number) {
    if (this.allLibraryMenu[i].libraryName) {
      this.allLibraryMenu[i].isLibraryNameRequired = false;
      this.allLibraryMenu[i].isLibraryNameExist = false;
    }
  }
  openRulebookLibraryAutoComplete() {
    if (!this.rulebookAutocomplete.isOpen) {
      this.trigautoRulebook.openPanel();
    }
  }
  libraryNamechange(row:number) {
    const indexes:any = this.allLibraryMenu.map((_, index) => index).filter(index => this.allLibraryMenu[index].libraryName.toLowerCase() == this.allLibraryMenu[row].libraryName.toLowerCase());
    if (indexes && indexes.length >= 1 && indexes!=row) {
      this.allLibraryMenu[row].isLibraryNameExist = true;
    }
  }
  filterRulebooks(){
    this.gdprService.getUsedRuleBookDD().subscribe((result: any) => {
      let usedRulebook: FilterViewModel[]=result;
      this.searchedRulebook= this.allRulebook.filter((value) => !usedRulebook.some((item) => item.name === value.name));
    });
  }

}
export interface ICollapsedOrOpen {
  value: boolean;
  title: string;
}
